<template>
  <article class="px-2 pb-5">
    <div class="title">
      <h3 v-if="more">新闻资讯</h3>
      <!-- <span
        v-if="more"
        class="more"
        @click="$router.push({name: 'news'})">更多资讯</span> -->
    </div>
    <a
      v-for="(item, index) of list"
      :href="item.url"
      :key="index"
      class="news">
      <section class="news-box">
        <img
          v-if="item.img"
          :src="item.img"
          alt=""
          class="news-box__image">
        <div class="news-box__text">
          <h4
            :style="newsTitleStyle"
            class="news-box__text__title mb-2">
            {{ item.title }}
          </h4>
          <div class="text-right">
            <small class="news-box__text__readed">{{ item.view }}次浏览</small>
          </div>
        </div>
      </section>
    </a>
    <div
      v-if="more"
      class="more"
      @click="$router.push({name: 'news'})">查看更多 ></div>
  </article>
</template>

<script>
// import News from './news.json';


export default {
  name: 'HomeNews',
  props: {
    list: {
      type: Array,
      default: () => {
        const list = [];
        return list;
      },
    },
    more: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    newsTitleStyle() {
      return {
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
      };
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.title {
  position: relative;
}

.more {
  font-size: 18px;
  text-align: center;
  padding: 8px 0;
  color: #b5b5b5;
}

.more:hover {
  font-weight: bold;
}

.news {
  border-bottom: solid 1px #f0f0f0;
  display: block;
}

.news:last-child {
  border-bottom-color: transparent;
}

.news-box {
  padding: 1rem 0;
  display: flex;
}

.news-box__text {
  flex: 1;
  padding: 0 0.5rem;
}

.news-box__text__title {
  margin: 0;
  font-weight: 400;
  color: #000;
  height: 42px;
}

.news-box__text__readed {
  color: #b5b5b5;
}

.news-box__image {
  width: 100px;
  height: 75px;
}
</style>
